angular.module('gestioneAttiApp').directive('sedutaDocumentToolbar', function () {
    return {
        restrict: "E",
        templateUrl: 'app/components/sedutaDocumentToolbar/sedutaDocumentToolbar.directive.html',
        scope: {
            changeDocumentTypeCallback: '&?',
            changeDocumentVisibilityCallback: '&?',
            removeDocumentCallback: '&?',
            documentTypes: '=?',
            editable: '=',
            publicView: '=?',
            seduta: '=',
            ordineDelGiorno: "=?",
            uploadedFileCallback: '&',
            user: '='
        },
        transclude: false,
        controllerAs: 'vm',
        bindToController: true,
        controller: ['Seduta', 'Documento', 'AnagraficaProtocollo', 'toastr', 'FileSaver', '$timeout', '$uibModal', 'Principal', 'GESTIONE_ATTI_DOC_VISIBILITIES', 'MAX_UPLOAD_SIZE', '$mdDialog', 'User', '$anchorScroll','$state', 'PROTOCOLLAZIONE_DISABILITATA',
            function (Seduta, Documento, AnagraficaProtocollo, toastr, FileSaver, $timeout, $uibModal, Principal, GESTIONE_ATTI_DOC_VISIBILITIES, MAX_UPLOAD_SIZE, $mdDialog, User, $anchorScroll, $state, PROTOCOLLAZIONE_DISABILITATA) {
                var vm = this;

                vm.instantProtocolEnabled = vm.user && vm.user.instantProtocolEnabled;

                initUserRoles();
                initDocVisibilities();
                initToolbarSectionVisibilities();

                vm.commissionPresidentOrMember = false;

                vm.uploadPanel = 'app/components/sedutaDocumentToolbar/sedutaDocumentToolbar.uploadPanel.html';
                vm.documentsPanel = 'app/components/sedutaDocumentToolbar/sedutaDocumentToolbar.documentsPanel.html';
                vm.documentTableBody = 'app/components/sedutaDocumentToolbar/sedutaDocumentToolbar.documentTableBody.html';

                vm.docTypes = vm.documentTypes || [];
                vm.odg = vm.ordineDelGiorno || {'id': null};

                vm.files = [];
                vm.uploading = false;
                vm.protocolGroups = [];
                vm.singleFilesCount = 0;
                vm.singleDocumentsCount = 0;

                vm.defaultVisibility = "INTRANET";

                vm.frontespieceAllowedExtensions = ['pdf'];

                vm.canChangeDocumentType = canChangeDocumentType;
                vm.canChangeDocumentVisibility = canChangeDocumentVisibility;
                vm.changeDocumentType = changeDocumentType;
                vm.changeDocumentVisibility = changeDocumentVisibility;
                vm.closeDocumentToolbarPanels = closeDocumentToolbarPanels;
                vm.deleteDocument = deleteDocument;
                vm.downloadDocument = downloadDocument;
                vm.downloadGroupDocuments = downloadGroupDocuments;
                vm.dragOverClass = dragOverClass;
                vm.isDeletable = isDeletable;
                vm.isRealGroup = isRealGroup;
                vm.isSingleFileGroup = isSingleFileGroup;
                vm.loadDocuments = loadDocuments;
                vm.onFileSelect = onFileSelect;
                vm.openProtocolDataDialog = openProtocolDataDialog;
                vm.openSenderReceiverDialog = openSenderReceiverDialog;
                vm.removeGroupUpload = removeGroupUpload;
                vm.removeSingleUpload = removeSingleUpload;
                vm.resetUploads = resetUploads;
                vm.retryProcolAction = retryProcolAction;
                vm.setDefaultVisibility = setDefaultVisibility;
                vm.setPrimaryDoc = setPrimaryDoc;
                vm.setProtocolStateForGroup = setProtocolStateForGroup;
                vm.setProtocolStateForSingle = setProtocolStateForSingle;
                vm.uploadFiles = uploadFiles;

                vm.loadDocuments(false);

                vm.setProtocolStateForAllFilesOfGroup = function(group) {
                    angular.forEach(group.documents, function (file) {
                        file.protocolState = group.protocolState;
                    });
                };

                vm.protocolOptions = [
                    {
                        'value': 'NO_ARCHIVE',
                        'textKey': 'documentToolbar.noArchive'
                    }
                ];
                
                if(vm.odg.id || vm.seduta.id) {
                    vm.protocolOptions.push({
                        'value': 'ALREADY_ARCHIVED',
                        'textKey': 'documentToolbar.alreadyArchived'
                    });
                    if (!PROTOCOLLAZIONE_DISABILITATA) {
                        vm.protocolOptions.push({
                            'value': 'ARCHIVE_NOW',
                            'textKey': 'documentToolbar.toBeImmediatelyArchived'
                        });
                    }
                }

                // by Anno too
                vm.orderByNumeroProtocolloConsiglio = function(v1, v2){
                    if(!v2) {
                        return 1;
                    }
                    var doc1 = v1.value.documents[0];
                    var doc2 = v2.value.documents[0];
                    if(!doc1 || !doc1.datiProtocollo || !doc1.datiProtocollo.numeroProtocolloConsiglio) {
                        return -1;
                    } else if(!doc2 || !doc2.datiProtocollo || !doc2.datiProtocollo.numeroProtocolloConsiglio) {
                        return 1;
                    } else {
                        var dataProtCons1 = new Date(doc1.datiProtocollo.dataProtocolloConsiglio);
                        var dataProtCons2 = new Date(doc2.datiProtocollo.dataProtocolloConsiglio);
                        // Protocolli di anno differente possono avere un numero uguale o inferiori, quindi prima si ordina per anno
                        if (dataProtCons1 && dataProtCons2 && dataProtCons1.getFullYear() !== dataProtCons2.getFullYear()) {
                            if (dataProtCons1.getFullYear() < dataProtCons2.getFullYear()) {
                                return 1;    
                            } else {
                                return -1;
                            }
                        }
                        if(doc1.datiProtocollo.numeroProtocolloConsiglio <= doc2.datiProtocollo.numeroProtocolloConsiglio){
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                };

                vm.toggleUpload = function () {
                    if (vm.showUpload) {
                        vm.showUpload = false;
                        vm.showCloseAll = false;
                    } else {
                        vm.showUpload = true;
                        vm.showCloseAll = true;
                        vm.showDocuments = false;
                    }
                };

                vm.toggleDocuments = function () {
                    if (vm.showDocuments) {
                        vm.showDocuments = false;
                        vm.showCloseAll = false;
                    } else {
                        vm.showDocuments = true;
                        vm.showCloseAll = true;
                        vm.showUpload = false;
                    }
                };

                // vm.section.showDocuments = function(){
                //     vm.showDocuments = true;
                //     vm.showCloseAll = true;
                //     vm.showUpload = false;
                // };

                vm.cancelUpload = function () {
                    vm.resetUploads();
                    vm.uploading = false;
                    vm.showUpload = false;
                    vm.protocolGroups = [];
                    vm.singleFilesCount = 0;
                    vm.singleDocumentsCount = 0;
                };

                function loadDocuments(pollForProtocolUpdates) {
                    vm.existingDocs = [];
                    vm.groupedDocs = {};
                    if (vm.seduta) {
                        Seduta.getSedutaDocuments({id: vm.seduta.id, idOdg: vm.odg.id}, function (result) {
                            vm.groupedDocs = result.data;
                            calculateSingleDocGroups(vm.groupedDocs);
                            if (pollForProtocolUpdates) {
                                updateArchiveNowProtocolState(vm.groupedDocs);
                            }
                        }, function () {
                            toastr.error('Impossibile ottenere la lista dei documenti caricati', 'Errore!');
                        });
                    }
                }

                function openProtocolDataDialog(group) {
                    var doc = group.documents[0];
                    doc.protocoldDataOpen = true;
                    $mdDialog.show({
                        templateUrl: 'app/components/documentToolbar/protocol-data-dialog-editable.html',
                        controller: ['$scope', '$mdDialog', 'Seduta', 'entity', 'protocolState', 'editable', 'idSeduta', 'idOdg', 'documents', 'documento', 'group', 'anagrafiche',
                            function ($scope, $mdDialog, Seduta, entity, protocolState, editable, idSeduta, idOdg, documents, documento, group, anagrafiche) {
                                var vm = this;
                                vm.protocolData = entity || {};
                                vm.protocolState = protocolState;
                                vm.editable = editable;
                                vm.documents = documents;
                                vm.documento = documento;
                                vm.anagrafiche = anagrafiche;
                                vm.selectedSenderSearchText = '';
                                vm.selectedReceiverSearchText = '';
                                vm.group = group;
                                Seduta.getFilingCode({'id': idSeduta}, {}, function (value) {
                                    vm.protocolData.classificazioneArchivistica = value.data;
                                }, function (reason) {
                                    toastr.error('Impossibile Recuperare il Codice Classificazione ', 'Errore!');
                                });

                                vm.dataProtocolloMittenteAusiliare;

                                vm.dataProtocolloMittenteAusiliareChanged = function() {
                                    vm.protocolData.dataProtocolloMittente = vm.dataProtocolloMittenteAusiliare;
                                };
                                
                                vm.isDataProtocolloMittentiWrong = function(){
                                    if(!vm.protocolData || !vm.protocolData.dataProtocolloMittente){
                                        return true;
                                    }
                                    var data = new Date(vm.protocolData.dataProtocolloMittente);
                                    if(data.getFullYear() == 1000) {
                                        return true;
                                    }
                                    return false;
                                };

                                vm.clear = function () {
                                    $mdDialog.cancel();
                                };

                                vm.checkProtocolState = function (protocolState) {
                                    return protocolState === 'ALREADY_ARCHIVED';
                                };

                                vm.saveProtocolData = function () {
                                    // Non è possibile salvare i dettagli se è presente solo uno tra "dataProtocolloConsiglio" e "numeroProtocolloConsiglio"
                                    if(vm.protocolData.dataProtocolloConsiglio && !vm.protocolData.numeroProtocolloConsiglio 
                                        || !vm.protocolData.dataProtocolloConsiglio && vm.protocolData.numeroProtocolloConsiglio) {
                                        toastr.error('Inserire sia il numero di protocollo che la data di protocollo', 'Errore!');
                                        return;
                                    }
                                    if(vm.protocolData && vm.protocolData.dataProtocolloConsiglio && vm.protocolData.dataProtocolloConsiglio instanceof Date) {
                                        // Quando la data è impostata dal datepicker è di tipo Date
                                        //Converte la data in UTC altrimenti da BE viene fatto un parsing errato
                                        var newDataProtCons = new Date(Date.UTC(vm.protocolData.dataProtocolloConsiglio.getFullYear(), 
                                        vm.protocolData.dataProtocolloConsiglio.getMonth(),
                                        vm.protocolData.dataProtocolloConsiglio.getDate()));
                                        vm.protocolData.dataProtocolloConsiglio = newDataProtCons;
                                    } // Altrimenti La data è in formato stringa "dd-MM-yyyy" quindi non è stata modificata
                                    angular.forEach(vm.documents, function (doc) {
                                        doc.datiProtocollo = vm.protocolData;
                                    });
                                    Seduta.updateFileProtocolData(idSeduta, idOdg, documents).then(
                                            function (response) {
                                                toastr.success('Dati di protocollazione salvati', 'Successo!');
                                            },
                                            function (response) {
                                                toastr.error('Impossibile salvare i dati di protocollazione', 'Errore!');
                                            });
                                    vm.clear();
                                };

                                vm.addPersonToList = function (chip) {
                                    // If it is an object, it's already a known chip
                                    if (angular.isObject(chip)) {
                                        return chip;
                                    }
                                    // Otherwise, create a new one
                                    return {descrizione: chip};
                                };


                                vm.searchFirmatari = function (searchText) {

                                    if(searchText.length < 3) {
                                        return [];
                                    }
                            
                                    return AnagraficaProtocollo.search(
                                        { 
                                            term: searchText,
                                            protocolSystem: vm.documento.protocolSystem,
                                            page: 0,
                                            size: 20
                                        }).$promise.then(onSuccessAnag, onErrorAnag);
                        
                                    //var lista = vm.anagrafiche;
                                    //return searchText ? lista.filter(createFilterFor(searchText)) : [];
                                };

                                function onSuccessAnag(data, headers) {
                                    vm.anagrafiche = data;
                                    return data;
                                }
                        
                                function onErrorAnag(error) {
                                    console.log("Errore nel recupero anagrafiche!", error);
                                }

                                function createFilterFor(query) {
                                    var lowercaseQuery = angular.lowercase(query);

                                    return function filterFn(firmatario) {
                                        var codice = firmatario.codice ? firmatario.codice.toLowerCase() : '';
                                        var descrizione = firmatario.descrizione ? firmatario.descrizione.toLowerCase() : '';
                                        return (codice.indexOf(lowercaseQuery) >= 0 || descrizione.indexOf(lowercaseQuery) >= 0);
                                    };
                                }
                            }],
                        controllerAs: 'vm',
                        size: 'lg',
                        locals: {
                            entity: doc.datiProtocollo || doc.protocolData,
                            protocolState: doc.statoProtocollo || doc.protocolState,
                            editable: vm.isAdmin || vm.isProtocollo || vm.editable,
                            idSeduta: vm.seduta.id,
                            idOdg: vm.odg.id,
                            documents: group.documents,
                            documento: doc,
                            group: group,
                            anagrafiche: AnagraficaProtocollo.query({}).$promise,
                        }
                    });
                }

                function openSenderReceiverDialog(group, docIdx) {
                    var currDoc = group.documents[docIdx];
                    var currGroup = group;
                    $mdDialog.show({
                        templateUrl: 'app/components/documentToolbar/protocol-data-sender-receiver-dialog.html',
                        controller: 'SenderReceiverDialogController',
                        //size: 'lg',
                        fullscreen: true,
                        controllerAs: 'vm',
                        locals: {
                            $mdDialog: $mdDialog,
                            anagrafiche: AnagraficaProtocollo.query({}).$promise,
                            uffici: AnagraficaProtocollo.query({}).$promise,//AnagraficaProtocollo.listOffices({}).$promise,
                            document: currDoc,
                            group: currGroup
                        }
                    });
                }

                function calculateSingleDocGroups(groupedDocs) {
                    var single = 0;
                    angular.forEach(groupedDocs, function (group) {
                        if (group.documents.length === 1) {
                            single++;
                        }
                    });
                    vm.singleDocumentsCount = single;
                }

                function updateArchiveNowProtocolState(groupedDocs) {
                    var archiveNowCounts = 0;
                    angular.forEach(groupedDocs, function (group) {
                        angular.forEach(group.documents, function (sedutaDoc) {
                            if (sedutaDoc.protocolState === 'ARCHIVE_NOW') {
                                archiveNowCounts++;
                                Documento.getDocSeduta(sedutaDoc.id).then(function (result) {
                                    var resultDoc = result.data;
                                    if (resultDoc.statoProtocollo === 'ARCHIVED' || resultDoc.statoProtocollo === 'ERROR') {
                                        sedutaDoc.protocolData = resultDoc.datiProtocollo;
                                        sedutaDoc.protocolState = resultDoc.statoProtocollo;

                                        sedutaDoc.datiProtocollo = resultDoc.datiProtocollo;

                                        group.protocolState = resultDoc.statoProtocollo;
                                        archiveNowCounts--;
                                    }
                                });
                            }
                        });
                    });

                    if (archiveNowCounts > 0) {
                        $timeout(function () {
                            updateArchiveNowProtocolState(groupedDocs);
                        }, 5000);
                    }
                }

                function validate() {
                    for (var j = 0; j < vm.protocolGroups.length; j++) {
                        var primaryFound = false;
                        for (var i = 0; i < vm.protocolGroups[j].documents.length; i++) {
                            var file = vm.protocolGroups[j].documents[i];
                            primaryFound = primaryFound || file.primary;
                            if (!file.docType || !file.protocolState || !file.visibility) {
                                return false;
                            } else if ((file.protocolState === 'ARCHIVE_NOW' || file.protocolState === 'TO_BE_ARCHIVED')
                                    && (!vm.protocolGroups[j].mittenti || vm.protocolGroups[j].mittenti.length <= 0
                                            || !vm.protocolGroups[j].destinatari || vm.protocolGroups[j].destinatari.length <= 0)) {
                                return false;
                            } else if((file.protocolState === 'ARCHIVE_NOW' || file.protocolState === 'TO_BE_ARCHIVED') && !vm.protocolGroups[j].operatingOfficeSelected) {
                                return false;
                            }
                        }
                        if (!primaryFound) {
                            return false;
                        }
                    }
                    return true;
                }


                function closeDocumentToolbarPanels() {
                    vm.showUpload = false;
                    vm.showDocuments = false;
                    vm.showCloseAll = false;
                }

                function onFileSelect($files) {
                    if($files.length === 0) {
                        return;
                    }
                    var tooBigFiles = [];

                    angular.forEach($files, function (file) {
                        var lastIterator = getAlreadyUploadedGreaterGroupNumber(vm.groupedDocs) + vm.protocolGroups.length;
                    // var lastIterator = vm.groupedDocs.length + vm.protocolGroups.length;
                        if (file.size > MAX_UPLOAD_SIZE) {
                            tooBigFiles.push(file.name);
                        } else {
                            var newSingleUpload = {
                                documents: [],
                                name: lastIterator + 1,
                                protocolState: null,
                                isGroup: false,
                            };

                            file.frontpieceDisabled = isFrontpieceDisabled(file);

                            newSingleUpload.documents.push({
                                name: file.name,
                                type: file.type,
                                size: file.size,
                                protocolGroup: newSingleUpload.name,
                                protocolState: null,
                                protocolOptions: vm.protocolOptions,
                                visibilityStates: vm.visibilityStates,
                                docType: null,
                                frontpiece: false,
                                notArchive: true,
                                frontpieceDisabled: file.frontpieceDisabled,
                                progress: 0,
                                file: file,
                                primary: true,
                                protocolSystem: "JOSH_PROTOCOL"
                            });
                            vm.protocolGroups.push(newSingleUpload);
                            vm.singleFilesCount++;
                        }
                    });
                    

                    displayTooBigFilesWarning(tooBigFiles);
                    $files = [];
                }

                function getAlreadyUploadedGreaterGroupNumber(groupList) {
                    var maxValue = 0;
                    angular.forEach(groupList, function(group) {
                        if(group.name > maxValue) {
                            maxValue = group.name;
                        }        
                    });
                    return maxValue;
                }

                function changeDocumentType(sedutaDoc) {
                    if (!vm.docTypesById) {
                        initDocTypesById();
                    }
                    var newDocumentType = vm.docTypesById[sedutaDoc.tipoDocumento.id];
                    vm.changeDocumentTypeCallback({document: sedutaDoc, newDocumentType: newDocumentType});
                }

                function changeDocumentVisibility(sedutaDoc) {
                    vm.changeDocumentVisibilityCallback({document: sedutaDoc, newDocumentVisibility: sedutaDoc.visibilita});
                }

                function uploadFiles() {
                    var valid = validate();
                    if (!valid) {
                        toastr.error('Per ogni file o gruppo che carichi devi specificare:<ul><li>Tipo Documento</li><li>Tipo Protocollazione</li><li>Visibilità</li></ul>', {
                            timeOut: 60000,
                            extendedTimeOut: 0
                        });
                        return;
                    }

                    vm.uploading = true;

                    //files: an array of files selected, each file has name, size, and type.
                    vm.resetUploads();
                    var totalFiles = 0;
                    var uploadCounter = 0;
                    for (var j = 0; j < vm.protocolGroups.length; j++) {
                        var mittentiId = [];
                        var destinatariId = [];
                        if (vm.protocolGroups[j].documents.length > 0) {
                            angular.forEach(vm.protocolGroups[j].mittenti, function (mittente) {
                                mittentiId.push(mittente.id);
                            });

                            angular.forEach(vm.protocolGroups[j].destinatari, function (destinatario) {
                                destinatariId.push(destinatario.id);
                            });
                        }
                        setProtocolStateForGroup(vm.protocolGroups[j]);
                        for (var i = 0; i < vm.protocolGroups[j].documents.length; i++) {
                            var file = vm.protocolGroups[j].documents[i];
                            totalFiles++;
                            var params = {
                                protocolSystem: file.protocolSystem,
                                idTipoDocumento: file.docType.id,
                                visibilita: file.visibility,
                                frontespizio: file.frontpiece,
                                gruppoProtocollo: file.protocolGroup,
                                statoProtocollo: file.protocolState,
                                primario: file.primary,
                                operatingOffice: vm.protocolGroups[j].operatingOfficeSelected                                
                            };

                            function updateProgress(fileRef) {
                                return function (evt) {
                                    fileRef.progress = parseInt(100.0 * evt.loaded / evt.total);
                                    fileRef.progress = 'info';
                                };
                            }

                            function uploadOutcomeHandler(fileRef, success, iterator) {
                                return function (status) {
                                    fileRef.progress = success ? 100 : fileRef.progress;
                                    fileRef.progressClass = success ? 'success' : 'danger';
                                    uploadCounter++;

                                    if (success) {
                                        if (vm.uploadedFileCallback) {
                                            vm.uploadedFileCallback({documento: fileRef});
                                        }
                                    } else {
                                        var message = 'Impossibile caricare il file: ' + fileRef.name;
                                        if (status && status.message) {
                                            message += '. ERRORE: ' + status.message;
                                        }
                                        toastr.error(message, 'Errore!');
                                    }

                                    if (uploadCounter === totalFiles) {
                                        if(vm.odg.id){
                                            Seduta.protocolNow({id: vm.seduta.id, idOdgDoc: vm.odg.id}, {}, function (result) {
                                            }, function () {
                                                toastr.error('Impossibile completare la protocollazione', 'Errore!');
                                            });
                                            vm.loadDocuments(true);
                                        } else {
                                            vm.loadDocuments(false);
                                        }
                                        vm.uploads = [];

                                        if (success) {
                                            var p1 = $timeout(vm.cancelUpload, 2000);
                                            p1.then(function(){
                                                return $timeout(vm.toggleDocuments);
                                            });
                                        }
                                    }
                                };
                            }
                            //params.mittenti = params.mittenti || [];
                            //params.destinatari = params.mittenti || [];
                            //if(file.primary) {
                            params.mittenti = JSON.stringify(mittentiId);
                            params.destinatari = JSON.stringify(destinatariId);
                            //}
                            if(vm.odg.id) {
                                params.idOdg = vm.odg.id;
                            }
                            var currUpload = Seduta.uploadFileSeduta(vm.seduta.id, file.file, params)
                                    .progress(updateProgress(file))
                                    .success(uploadOutcomeHandler(file, true, j))
                                    .error(uploadOutcomeHandler(file, false));

                            vm.uploads.push(currUpload);
                        }
                    }
                }

                function dragOverClass($event) {
                    var items = $event.dataTransfer.items;
                    var hasFile = false;
                    if (items !== null) {
                        for (var i = 0; i < items.length; i++) {
                            if (items[i].kind === 'file') {
                                hasFile = true;
                                break;
                            }
                        }
                    } else {
                        hasFile = true;
                    }
                    return hasFile ? "dragover" : "dragover-err";
                }

                function resetUploads() {
                    if (vm.uploads) {
                        angular.forEach(vm.uploads, function (upload) {
                            upload.abort();
                        });
                    }
                    vm.uploads = [];
                }

                function downloadDocument(docId, docName) {
                    Documento.getDocSedutaContent(docId).then(function (result) {
                        if (result) {
                            FileSaver.saveAs(new Blob([result.data], {}), docName);
                        }
                    }, function () {
                        toastr.error('Impossibile scaricare il documento', 'Errore!');
                    });
                }

                function downloadGroupDocuments(group) {
                    Documento.getGroupArchive(vm.section.id, group, publicView).then(function (result) {
                        if (result) {
                            FileSaver.saveAs(new Blob([result.data], {}), 'Sezione-' + vm.section.id + '_' + group + '.zip');
                        }
                    }, function () {
                        toastr.error('Impossibile scaricare i documenti', 'Errore!');
                    });
                }

                function removeSingleUpload(group, docIdx) {
                    angular.forEach(group.documents, function (document, iterator) {
                        var currDoc = document;
                        if (currDoc.id === docIdx) {
                            if (vm.removeDocumentCallback) {
                                vm.removeDocumentCallback({documento: currDoc});
                            }
                        }
                    });
                    group.documents.splice(docIdx, 1);
                    if (!group.isGroup) {
                        vm.singleFilesCount--;
                    } else if (group.documents && group.documents.length === 1) {
                        vm.singleFilesCount++;
                    }
                }

                function removeGroupUpload(group) {
                    for (var idx = 0; idx < vm.protocolGroups.length; idx++) {
                        if (vm.protocolGroups[idx].name === group.name) {
                            break;
                        }
                    }
                    vm.protocolGroups.splice(idx, 1);
                }

                function deleteDocument(docId) {
                    $uibModal.open({
                        template: '<div class="modal-header">\
                            <h4 class="modal-title" ng-bind="title"></h4>\
                        </div>\
                        <div class="modal-body" ng-bind="::modalVm.deleteConfirmMsg"></div>\
                        <div class="modal-footer">\
                            <button class="btn btn-default" ng-click="modalVm.deleteDoc()" ng-bind="::modalVm.confirmBtnText"></button>\
                            <button class="btn btn-primary" ng-click="modalVm.cancel()" ng-bind="::modalVm.cancelBtnText"></button>\
                        </div>',
                        controller: ['$uibModalInstance', '$translate', function ($uibModalInstance, $translate) {
                            var modalVm = this;
                            modalVm.deleteConfirmMsg = $translate.instant('documentToolbar.deleteConfirmMsg');
                            modalVm.confirmBtnText = $translate.instant('entity.action.delete');
                            modalVm.cancelBtnText = $translate.instant('entity.action.cancel');

                            modalVm.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                            modalVm.deleteDoc = function () {
                                Documento.deleteDocSedutaContent(docId).then(function () {
                                    for (var i = 0; i < vm.groupedDocs.length; i++) {
                                        var currentGroup = vm.groupedDocs[i];
                                        var isSingleDoc = currentGroup.documents.length === 1;
                                        angular.forEach(vm.groupedDocs[i].documents, function (document, iterator) {
                                            var currDoc = document;
                                            if (currDoc.id === docId) {
                                                if (vm.removeDocumentCallback) {
                                                    vm.removeDocumentCallback({documento: currDoc});
                                                }
                                                currentGroup.documents.splice(iterator, 1);
                                                if (currentGroup.documents.length === 0) {
                                                    if (isSingleDoc) {
                                                        vm.singleDocumentsCount--;
                                                    }
                                                    vm.groupedDocs.splice(i, 1);
                                                } else if (currentGroup.documents.length === 1) {
                                                    vm.singleDocumentsCount++;
                                                }
                                            }
                                        });
                                    }
                                    toastr.success('Eliminazione documento completata');
                                    $uibModalInstance.close();
                                }, function (error) {
                                    console.error(error);
                                    toastr.error('Impossibile eliminare il documento', 'Errore!');
                                });
                            };
                        }],
                        controllerAs: 'modalVm',
                        backdrop: 'static',
                        size: 'lg',
                    });
                }

                function setDefaultVisibility(sedutaDoc) {
                    if (sedutaDoc.docType ) {
                        if(isPublicSedutaDocument(sedutaDoc)) {
                            sedutaDoc.visibility = "PUBLIC";
                        } else if (sedutaDoc.docType.defaultVisibility) {
                            sedutaDoc.visibility = sedutaDoc.docType.defaultVisibility;
                        }
                    } else {
                        sedutaDoc.visibility = vm.defaultVisibility;
                    }
                }

                function isPublicSedutaDocument(sedutaDoc) {
                    return sedutaDoc.docType && 
                    (sedutaDoc.docType.codiceMnemonicoProtocollo === "X0005" || sedutaDoc.docType.codiceMnemonicoProtocollo === "X0510");
                }

                function setPrimaryDoc(documents, primaryDocIdx) {
                    var i = 0;
                    angular.forEach(documents, function (sedutaDoc) {
                        if (i === primaryDocIdx) {
                            sedutaDoc.primary = true;
                        } else {
                            sedutaDoc.primary = false;
                        }
                        i++;
                    });
                }

                function retryProcolAction(group) {
                    group.protocolState = 'ARCHIVE_NOW';
                    angular.forEach(group.documents, function (sedutaDoc) {
                        sedutaDoc.protocolState = 'ARCHIVE_NOW';
                    });
                    Documento.retryProtocolSedutaOdg( vm.seduta.id, vm.odg.id).then(function (result) {
                        if (angular.isArray(group)) {
                            updateArchiveNowProtocolState(group);
                        } else {
                            updateArchiveNowProtocolState([group]);
                        }
                    });
                }

                function canChangeDocumentType(sedutaDoc) {
                    if ($state.current.name !== 'seduta-detail.edit') {
                        return false;
                    }
                    // if (!vm.isProtocollo) {
                    //     return false;
                    // }

                    if (sedutaDoc.owner.id === 'SYSTEM') {
                        return true;
                    }

                    // if (document.owner.authorities) {
                    //     for (var i = 0; i < document.owner.authorities.length; i++) {
                    //         var auth = document.owner.authorities[i];
                    //         if (auth.name === 'ROLE_PROTOCOLLO') {
                    //             return true;
                    //         }
                    //     }
                    // }

                    return true;
                }

                function canChangeDocumentVisibility(sedutaDoc) {
                    if ($state.current.name !== 'seduta-detail.edit') {
                        return false;
                    }
                    if (vm.isAdmin) { 
                        return true;
                    }

                    var authorities = [];
                    authorities = getDocumentAuthorities(sedutaDoc, vm.seduta.legislatura);

                    if(sedutaDoc.owner.id === 'SYSTEM' && vm.isProtocollo) {
                        return true;
                    }

                    if (!vm.editable || sedutaDoc.owner.id === 'SYSTEM' || !Principal.hasAnyAuthority(authorities, vm.seduta.legislatura)) {
                        return false;
                    }

                    if (sedutaDoc.owner.id === vm.user.id) {
                        return true;
                    }

                    var documentCommissioni = getDocumentCommissioni(sedutaDoc, vm.seduta.legislatura);
                    var documentExternalSubjects = getDocumentExternalSubjects(sedutaDoc, vm.seduta.legislatura);
                    
                    if (vm.isCommissione) {
                        return User.hasAnyCommission(vm.user, documentCommissioni, vm.seduta.legislatura) && User.isCommissionRole(vm.user, 'Dipendente', vm.seduta.legislatura);
                    } else if (vm.isSettore) {
                        return User.hasAnySector(vm.user, sedutaDoc.owner.settori);
                    } else if (vm.isExternal) {
                        return User.hasAnyExternalSubject(vm.user, documentExternalSubjects, vm.seduta.legislatura);
                    } else {
                        return true;
                    }
                }

                function getDocumentAuthorities(sedutaDoc, legislatura) {
                    var authorities = [];
                    // Authorities globali
                    if (sedutaDoc.owner.authorities) {
                        angular.forEach(sedutaDoc.owner.authorities, function (auth) {
                            if (auth.name !== 'ROLE_USER') {
                                authorities.push(auth.name);
                            }
                        });
                    }
                    // Authorities per legislatura: solo quella dell'atto corrente
                    if (sedutaDoc.owner.legislaturaAuthorities && legislatura) {
                        angular.forEach(sedutaDoc.owner.legislaturaAuthorities, function (legiAuth) {
                            if (
                                legiAuth &&
                                legiAuth.legislatura &&
                                legiAuth.legislatura.legislatura === legislatura &&
                                legiAuth.authorities
                            ) {
                                angular.forEach(legiAuth.authorities, function (auth) {
                                    if (auth.name !== 'ROLE_USER') {
                                        authorities.push(auth.name);
                                    }
                                });
                            }
                        });
                    }
                    return authorities;
                }

                function getDocumentCommissioni(sedutaDoc, legislatura) {
                    var docCommissioni = [];
                    // Commissioni globali (gestione pregresso)
                    if (sedutaDoc.owner.commissioni) {
                        angular.forEach(sedutaDoc.owner.commissioni, function (comm) {
                            docCommissioni.push(comm);
                        });
                    }
                    // Commissioni per legislatura: solo quella della legislatura della seduta
                    if (sedutaDoc.owner.legislaturaAuthorities && legislatura) {
                        angular.forEach(sedutaDoc.owner.legislaturaAuthorities, function (legiAuth) {
                            if (
                                legiAuth &&
                                legiAuth.legislatura &&
                                legiAuth.legislatura.legislatura === legislatura &&
                                legiAuth.commissioneRuoloAssociato &&
                                legiAuth.commissioneRuoloAssociato.commissione

                            ) {
                                docCommissioni.push(legiAuth.commissioneRuoloAssociato.commissione);
                            }
                        });
                    }
                    return docCommissioni;
                }

                function getDocumentExternalSubjects(sedutaDoc, legislatura) {
                    var docSoggetti = [];
                    // Soggetti globali (gestione pregresso)
                    if (sedutaDoc.owner.soggettiEsterni) {
                        angular.forEach(sedutaDoc.owner.soggettiEsterni, function (sogg) {
                            docSoggetti.push(sogg);
                        });
                    }
                    // Soggetti per legislatura: solo quella della legislatura della seduta
                    if (sedutaDoc.owner.legislaturaAuthorities && legislatura) {
                        angular.forEach(sedutaDoc.owner.legislaturaAuthorities, function (legiAuth) {
                            if (
                                legiAuth &&
                                legiAuth.legislatura &&
                                legiAuth.legislatura.legislatura === legislatura &&
                                legiAuth.soggettiEsterni

                            ) {
                                angular.forEach(legiAuth.soggettiEsterni, function (sogg) {
                                    docSoggetti.push(sogg);
                                });
                            }
                        });
                    }
                    return docSoggetti;
                }

                function displayTooBigFilesWarning(docs) {
                    if (!docs || docs.length === 0) {
                        return;
                    }
                    var msg = 'I seguenti file sono troppo grandi per essere caricati:';
                    angular.forEach(docs, function (doc) {
                        msg += '<br>&bullet;&nbsp;' + doc;
                    });
                    toastr.error('Attenzione', msg);
                }

                function initUserRoles() {
                    vm.isAuthenticated = Principal.isAuthenticated();
                    if (vm.isAuthenticated) {
                        vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN'], vm.seduta.legislatura);
                        vm.isProtocollo = Principal.hasAnyAuthority(['ROLE_PROTOCOLLO'], vm.seduta.legislatura);
                        vm.isCommissione = Principal.hasAnyAuthority(['ROLE_COMMISSIONE'], vm.seduta.legislatura);
                        vm.isSettore = Principal.hasAnyAuthority(['ROLE_SETTORE'], vm.seduta.legislatura);
                        vm.isExternal = Principal.hasAnyAuthority(['ROLE_EXTERNAL'], vm.seduta.legislatura);
                    }
                }

                function initDocTypesById() {
                    vm.docTypesById = {};
                    angular.forEach(vm.docTypes, function (docType) {
                        vm.docTypesById[docType.id] = docType;
                    });
                }

                function initDocVisibilities() {
                    vm.visibilityStates = [];

                    angular.forEach(GESTIONE_ATTI_DOC_VISIBILITIES, function (docVisibility) {
                        if (!docVisibility.onlyForCommission) {
                            if (docVisibility.value !== 'SECTION_VISIBILITY') {
                                vm.visibilityStates.push(docVisibility);
                            }
                        }
                    });

                }

                function initToolbarSectionVisibilities() {
                    vm.showCloseAll = false;
                    vm.showDocuments = false;
                    vm.showUpload = false;
                }

                function setProtocolStateForSingle(file) {
                    if (file.protocolState === 'NO_ARCHIVE') {
                        file.notArchive = true;
                        file.protocolGroup = 0;
                    } else {
                        file.notArchive = false;
                        //file.frontpiece = !isFrontpieceDisabled(file);
                    }
                }

                function setProtocolStateForGroup(group) {
                    angular.forEach(group.documents, function (file) {
                        file.protocolState = group.protocolState ? group.protocolState : file.protocolState;
                        if (file.protocolState === 'NO_ARCHIVE') {
                            file.notArchive = true;
                            file.protocolGroup = 0;
                        } else {
                            file.protocolGroup = group.name;
                            file.notArchive = false;
                            //file.frontpiece = !isFrontpieceDisabled(file);
                        }
                    });
                }

                function isSingleFileGroup(group) {
                    return !vm.isRealGroup(group);
                }

                function isRealGroup(group) {
                    return group && group.documents && group.documents.length > 1;
                }

                function isDeletable(doc) {
                    if (vm.isAdmin) {
                        return doc.protocolState !== "ARCHIVE_NOW" && vm.editable;
                    }
                    return doc.protocolState !== "ARCHIVED" && doc.protocolState !== "ARCHIVE_NOW"
                            && vm.editable;
                }

                function isFrontpieceDisabled(file) {
                    var getExtension = /(?:\.([^.]+))?$/;
                    var extension = getExtension.exec(file.name)[1];
                    if (typeof (extension) === 'undefined' || extension === null) {
                        extension = '';
                    } else {
                        extension = extension.trim().toLowerCase();
                    }
                    return vm.frontespieceAllowedExtensions.indexOf(extension) === -1;
                }


                // FOR ANCHORING TO THE DOCUMENTS 
                /*if(vm.section.anchorToDocuments) {
                    vm.section.showDocuments();
                    $timeout(function () {
                        $anchorScroll(vm.section.id);
                    }, 1500);
                }*/
            }]
    };

});
